export default {
	id: 'SIMPLE_PREMIUM_MALE_FALLBACK_1M_44_1W_4_15',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_44_1w_4_15_usd',
			EUR: 'simple_premium_1m_39_1w_4_79_eur',
			GBP: 'simple_premium_1m_29_99_1w_3_99_gbp',
			AUD: 'simple_premium_1m_49_99_1w_6_39_aud',
			CAD: 'simple_premium_1m_49_99_1w_6_39_cad',
			DKK: 'simple_premium_1m_259_1w_31_2_dkk',
			SEK: 'simple_premium_1m_399_1w_47_2_sek',
			NOK: 'simple_premium_1m_399_1w_47_2_nok',
			BRL: 'simple_premium_1m_99_1w_13_6_brl',
			MXN: 'simple_premium_1m_499_1w_63_2_mxn',
			TRY: 'simple_premium_1m_999_1w_135_2_try',
			ARS: 'simple_premium_1m_39990_1w_5272_ars',
			COP: 'simple_premium_1m_119990_1w_15992_cop',
			CLP: 'simple_premium_1m_29990_1w_3832_clp',
		},
		primer: 'prd_dt0Ho0SdKz06',
	},
}
